export const OPEN = 'OPEN';
export const CLOSE = 'CLOSE';

export function openMore() {
  return ({ type: OPEN});
}

export function closeMore() {
  return ({ type: CLOSE});
}